'use client';

import { Suspense } from 'react';
import { useSearchParams } from 'next/navigation';

function SessionExpiredBannerInner() {
  const searchParams = useSearchParams();
  const sessionExpired = searchParams?.get('reason') === 'session_expired';
  if (!sessionExpired) return null;
  return (
    <div className="mb-5 rounded-lg bg-amber-500/10 border border-amber-500/30 px-4 py-3 flex items-start gap-3">
      <svg className="h-5 w-5 text-amber-400 mt-0.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
      </svg>
      <div>
        <p className="text-sm font-medium text-amber-300">Session Expired</p>
        <p className="text-xs text-amber-400/80 mt-0.5">Your session has expired after 24 hours. Please sign in again.</p>
      </div>
    </div>
  );
}

export default function SessionExpiredBanner() {
  return (
    <Suspense fallback={null}>
      <SessionExpiredBannerInner />
    </Suspense>
  );
}
